/** Helper to toggle off dynamic id generator, accessibility, and animation during snapshot testing.
 * Defaults to false for animation and accessibility. Driven by Node env setting to 'test'.
 */
export const highchartsOptionsSetter = (
  Highcharts: any, // imported instance of Highcharts
  animationStatus = false,
  accessibilityStatus = false,
) => {
  if (
    process.env.NODE_ENV === 'test' ||
    process.env.NODE_ENV === 'development' ||
    /static-charts/g.test(window.location.search)
  ) {
    // eslint-disable-next-line
    Highcharts.useSerialIds(true);

    Highcharts.setOptions({
      accessibility: {
        enabled: accessibilityStatus,
      },
      lang: {
        rangeSelectorZoom: 'DATE RANGE',
      },
      plotOptions: {
        column: {
          animation: animationStatus,
        },
        scatter: {
          animation: animationStatus,
        },
        series: {
          animation: animationStatus,
        },
        solidgauge: {
          animation: animationStatus,
        },
        stockChart: {
          animation: animationStatus,
        },
      },
    });
  }
};
